import Image404 from "./404.png";
import ClientLogo from "./ClientLogo1.png";
import LandBlock1 from "./LandBlock1.png";
import LandBlock2 from "./LandBlock2.png";
import LandBlock from "./LandBlock.png";
import TBank from "./T-Bank.png";
import A3 from "./a3.png";
import AboutCompany2 from "./aboutCompany2.png";
import AboutCompany3 from "./aboutCompany3.png";
import AboutCompany from "./aboutCompany.png";
import allProjects1 from "./allProjects1.png";
import allProjects2 from "./allProjects2.png";
import allProjects3 from "./allProjects3.png";
import allProjects4 from "./allProjects4.png";
import allProjects5 from "./allProjects5.png";
import allProjects6 from "./allProjects6.png";
import allProjects7 from "./allProjects7.png";
import allProjects8 from "./allProjects8.png";
import allProjects from "./allProjects.png";
import Awards from "./awards.png";
import award5 from "./awards/bmu.jpg";
import award7 from "./awards/btv.jpg";
import award6 from "./awards/ias.jpg";
import award1 from "./awards/ivanova1.jpg";
import award2 from "./awards/toe.jpg";
import award3 from "./awards/tri.jpg";
import award4 from "./awards/vnv.jpg";
import ClientAvatar from "./clientAvatar1.png";
import Client1 from "./clients/client1.jpg";
import Client2 from "./clients/client2.jpg";
import Client3 from "./clients/client3.jpg";
import Client4 from "./clients/client4.jpg";
import Client5 from "./clients/client5.jpg";
import Client6 from "./clients/client6.jpg";
import ContactsHouse1 from "./contacts/house_1.png";
import ContactsHouse2 from "./contacts/house_2.png";
import ContactsLogoBot from "./contacts/logo-bot.png";
import ContactsLogoSi from "./contacts/logo-si.png";
import ContactsQrBot from "./contacts/qr-bot.svg";
import ContactsQrSi from "./contacts/qr-si.svg";
import ContactsBlock from "./contactsBlock.png";
import House1 from "./house1.png";
import House2 from "./house2.png";
import House3 from "./house3.png";
import House4 from "./house4.png";
import House5 from "./house5.png";
import House6 from "./house6.png";
import House from "./house.png";
import HouseBigImage from "./houseBigImg.png";
import HouseCard from "./houseCard.jpg";
import HouseSmallImage1 from "./houseSmallImg1.png";
import HouseSmallImage from "./houseSmallImg.png";
import OurHouses1 from "./houses_1.png";
import OurHouses2 from "./houses_2.png";
import OurHouses3 from "./houses_3.png";
import howWeWork1 from "./howWeWork1.png";
import howWeWork2 from "./howWeWork2.png";
import InvitationImg from "./invitationImg.png";
import LogoFooter from "./logoFooter.png";
import LogoHeader from "./logoHeader.png";
import MainProject1 from "./mainProject1.png";
import MainProject2 from "./mainProject2.png";
import MainProject from "./mainProject.png";
import ManageHousesBlock1 from "./manageHouses1.png";
import ManageHousesBlock2 from "./manageHouses2.png";
import ManageHousesBlock from "./manageHouses.png";
import OfficeKonst from "./office-konst.png";
import OfficeTutaev from "./office-tutaev.png";
import OfficeYar from "./office-yarosl.png";
import OurMission from "./ourMission.png";
import ParallaxImage1 from "./parallaxImage1.png";
import ParallaxImage from "./parallaxImage.png";
import Partner1 from "./partners/partner1.jpg";
import Partner2 from "./partners/partner2.jpg";
import Partner3 from "./partners/partner3.jpg";
import Partner4 from "./partners/partner4.jpg";
import Partner5 from "./partners/partner5.jpg";
import Partner6 from "./partners/partner6.jpg";
import Partner7 from "./partners/partner7.jpg";
import Partner8 from "./partners/partner8.jpg";
import Partner9 from "./partners/partner9.jpg";
import Partner10 from "./partners/partner10.jpg";
import Partner11 from "./partners/partner11.jpg";
import Partner12 from "./partners/partner12.jpg";
import Partner13 from "./partners/partner13.jpg";
import Partner14 from "./partners/partner14.jpg";
import Partner15 from "./partners/partner15.jpg";
import Partner16 from "./partners/partner16.jpg";
import A3icon from "./payment/a3icon.svg";
import Alpha from "./payment/alpha.svg";
import Sber from "./payment/sber.svg";
import Spb from "./payment/sbp.svg";
import Tbank from "./payment/tbank.svg";
import Tbankwhite from "./payment/tbankwhite.svg";
import ProjectImages1 from "./progectImages1.png";
import ProjectImages2 from "./progectImages2.png";
import ProjectImages3 from "./progectImages3.png";
import ProjectImages from "./progectImages.png";
import ProjectsMain from "./projectsMain.png";
import RepairBlock1 from "./repairBlock1.png";
import RepairBlock2 from "./repairBlock2.png";
import RepairBlock from "./repairBlock.png";
import TeamPhoto1 from "./teamPhoto1.png";
import TeamPhoto2 from "./teamPhoto2.png";
import TeamPhoto3 from "./teamPhoto3.png";
import VacancyIcon1 from "./vacancyIcon1.svg";
import VacancyIcon2 from "./vacancyIcon2.svg";
import VacancyIcon from "./vacancyIcon.svg";
import WeDoing from "./what/we-doing.png";
import WhatDoing1 from "./what/what-are-we-doing-1.png";
import WhatDoing2 from "./what/what-are-we-doing-2.png";
import WhatDoing3 from "./what/what-are-we-doing-3.png";
import WhatDoing4 from "./what/what-are-we-doing-4.png";

const images = {
  LogoFooter,
  LogoHeader,
  AboutCompany,
  AboutCompany2,
  AboutCompany3,
  A3,
  TBank,
  Image404,
  ParallaxImage,
  ParallaxImage1,
  OurMission,
  ClientLogo,
  TeamPhoto1,
  TeamPhoto2,
  TeamPhoto3,
  Awards,
  ClientAvatar,
  WeDoing,
  howWeWork1,
  howWeWork2,
  ContactsBlock,
  RepairBlock,
  RepairBlock1,
  RepairBlock2,
  LandBlock,
  LandBlock1,
  LandBlock2,
  ManageHousesBlock,
  ManageHousesBlock1,
  ManageHousesBlock2,
  allProjects,
  allProjects1,
  allProjects2,
  allProjects3,
  allProjects4,
  allProjects5,
  allProjects6,
  allProjects7,
  allProjects8,
  MainProject,
  MainProject1,
  MainProject2,
  ProjectsMain,
  ProjectImages,
  ProjectImages1,
  ProjectImages2,
  ProjectImages3,
  VacancyIcon,
  VacancyIcon1,
  VacancyIcon2,
  InvitationImg,
  OurHouses1,
  OurHouses2,
  OurHouses3,
  HouseSmallImage,
  HouseSmallImage1,
  HouseBigImage,
  House,
  House1,
  House2,
  House3,
  House4,
  House5,
  House6,
  HouseCard,
  award1,
  award2,
  award3,
  award4,
  award5,
  award6,
  award7,
  WhatDoing1,
  WhatDoing2,
  WhatDoing3,
  WhatDoing4,
  Partner1,
  Partner2,
  Partner3,
  Partner4,
  Partner5,
  Partner6,
  Partner7,
  Partner8,
  Partner9,
  Partner10,
  Partner11,
  Partner12,
  Partner13,
  Partner14,
  Partner15,
  Partner16,
  Client1,
  Client2,
  Client3,
  Client4,
  Client5,
  Client6,
  Spb,
  Alpha,
  Sber,
  Tbank,
  Tbankwhite,
  A3icon,
  OfficeKonst,
  OfficeYar,
  OfficeTutaev,
  ContactsHouse1,
  ContactsHouse2,
  ContactsLogoBot,
  ContactsLogoSi,
  ContactsQrBot,
  ContactsQrSi,
};

export default images;
